module.exports = __webpack_public_path__ + "static/media/SeaLighthouse-day.2dfddaa4.svg";